import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as overlayActions from '../overlayFull/overlayActions';
import * as galleryActions from './galleryActions';
import SlickTablet from './slickComponentTablet';
import SlickMobile from './slickComponentMobile';
import MobileZoom from './slickComponentMobileZoom';
import './gallerySliderStyle.less';

class GallerySlider extends Component {
  openFullScreenGallery() {
    const payload = {
      show: true,
      content: <MobileZoom />,
      type: 'full',
      pageYOffset: window.pageYOffset
    };

    this.props.POPULATE_CONTENT(payload);
  }

  renderVideoButton() {
    const { videos } = this.props.app.data;

    let vod = null;
    if (videos && videos.length > 0 && this.props.isMobile) {
      const videoOverlay = (
        <div
          id="zoomish"
          onClick={() => this.props.CLOSE_OVERLAY()}
          role="button"
          tabIndex="0"
          style={{ outline: 'none' }}
        >
          <div className="overlayClose" />
          <iframe
            className="border-0"
            title="gallery video"
            width="100%"
            src={videos[0].link}
            allowFullScreen
          />
        </div>
      );
      const payload = {
        show: true,
        content: videoOverlay,
        type: 'full',
        pageYOffset: window.pageYOffset
      };
      vod = (
        <div
          id="videoButton"
          onClick={() => this.props.POPULATE_CONTENT(payload)}
          role="button"
          tabIndex="0"
          style={{ outline: 'none' }}
        >
          <div>
            <span />
            Video
          </div>
        </div>
      );
    }
    return vod;
  }

  renderSlider(key) {
    const { isMobile } = this.props;
    if (isMobile) {
      return <SlickMobile key={key} />;
    }
    return <SlickTablet />;
  }

  render() {
    return (
      <div
        id="gallerySlider"
        className={this.props.app.data.videos ? '' : 'no-video'}
      >
        <div
          onClick={() => this.openFullScreenGallery()}
          role="button"
          tabIndex="0"
          style={{ outline: 'none' }}
        >
          {this.renderSlider('slider1')}
        </div>
        {this.renderVideoButton()}
      </div>
    );
  }
}

const mapStateToProps = ({ app, gallery, general }) => {
  return {
    app,
    gallery,
    isMobile: general.isMobile
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ ...galleryActions, ...overlayActions }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(GallerySlider);
